<div class="ui-g ui-fluid">
    <div class="ui-g-12 ui-lg-12 ui-md-12 background" >
        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <h2 class="title" >Envío de reclamo</h2>
          <h3 class="subTitle">Proceso para generar nuevo reclamo.</h3>
        </div>
    </div>
    <div class="cardGray3 ui-g-12 ui-md-12 ui-lg-12">
        <div class="ui-g-12">
           <div class="ui-g-12">
                <h2 class="subTitle3">Ingrese la siguiente información</h2>
           </div>
        </div>
        <div class="ui-g-12">
        <div class="ui-g-12 form-group">
            <div class="ui-g-12">
                <h4 class="subTitle2">Seleccione a quién va dirigido el reclamo.</h4>
                <p-dropdown [(ngModel)]="selectedDependent" [options]="dependents"    placeholder="Seleccione asegurado" optionLabel="policyHolderCompleteName" [showClear]="true" [virtualScroll]="false" [itemSize]="33" [filter]="false"></p-dropdown>
            </div>
            <!--<div class="ui-g-12">
                <h4 class="subTitle2">Seleccione el tipo de reclamo.</h4>
                <p-dropdown [(ngModel)]="selectedType" (onChange)="validate($event)" [options]="items"    placeholder="Seleccione tipo reclamo" optionLabel="name" [showClear]="true" [virtualScroll]="false" [itemSize]="33" [filter]="false"></p-dropdown> 
            </div>-->
           
            <div class="ui-g-12">
                <h4 class="subTitle2">Adjuntar imagen(es)</h4>
                <p-fileUpload 
                #form1
                name="myfile[]" 
                [customUpload]="true" 
                multiple="true"
                (uploadHandler)="customUploadImg($event.files, form1)"
                chooseLabel="Seleccionar imagen(es)"
                uploadLabel="Enviar solicitud"
                cancelLabel="Cancelar"
                accept="image/*"
                class="ui-button-primary ui-button-rounded" >
                </p-fileUpload>
            </div>
            <div class="ui-g-12">
                <h4 class="subTitle2">Adjuntar pdf</h4>
                <p-fileUpload 
                #form
                name="myfile[]" 
                [customUpload]="true" 
                (uploadHandler)="customUpload($event.files, form)"
                chooseLabel="Seleccionar pdf"
                uploadLabel="Enviar solicitud"
                cancelLabel="Cancelar"
                accept="application/pdf"
                class="ui-button-primary ui-button-rounded" >
                </p-fileUpload>
            </div>
                
            </div>
            <p-messages></p-messages>
        </div>
    </div>
    <p-dialog [(visible)]="firstView" [closable]="true" [style]="{width: '70vw'}">
        <div class="ui-g-12 background">
            <p class="title align" >Documentos importantes</p>
        </div>
        <div class="cardGray ui-g-12">
            <div class="ui-g-12 p-grid">
            <div class="ui-g-1 ui-md-3 ui-lg-3"></div>
            <div class="ui-g-12 ui-md-6 ui-lg-6">
                <h3 class="align">
                {{welcomeText}}
                </h3>
            </div>   
            <div class="ui-g-1 ui-md-3 ui-lg-3"></div>
            </div>
        </div>
    </p-dialog>
    <p-dialog [(visible)]="hospitalization" [closable]="true" [style]="{width: '70vw'}">
        <div class="ui-g-12 background">
            <p class="title align">Documentos importantes</p>
        </div>
        <div class="cardGray ui-g-12">
            <div class="ui-g-12 p-grid">
            <div class="ui-g-1 ui-md-3 ui-lg-3"></div>
            <div class="ui-g-12 ui-md-6 ui-lg-6">
                <h3 class="align">
                {{hospitalizationText}}
                </h3>
            </div>   
            <div class="ui-g-1 ui-md-3 ui-lg-3"></div>
            </div>
        </div>
    </p-dialog>
    <p-dialog [(visible)]="success"  [closable]="true" [style]="{width: '60vw'}">
        <div class="ui-g-12">
            <div class="ui-g-12 p-grid">
            <div class="ui-g-1 ui-md-2 ui-lg-2"></div>
            <div class="ui-g-12 ui-md-8 ui-lg-8 align">
                <img src="assets/images/authorization/message-authorization.png" alt="" style="width: 125px;">
                <h2 class="align title2 mgTop">¡Gracias por enviar su reclamo!</h2>
                <h3 class="align noMg">Se ha completado la petición con éxito</h3>
                <h2 class="align noMg">El número de solicitud es:</h2>
                <h2 class="align noMg">{{idTransApp}}</h2>
                <div class="align noMg"> <button  pButton type="button" class="ui-button-primary btn-dv" style="width: 100%;" label="Aceptar" (click)="navigateComponent('authorizations')"></button></div>  
            </div>   
            <div class="ui-g-1 ui-md-2 ui-lg-2"></div>
            
            </div>
        </div>
    </p-dialog>
    <div class="progress-spinner" *ngIf="loading">
        <img src="assets/images/Logo-1.gif" alt="" width="300px">
    </div>
  </div>
  